import React, { Fragment } from "react"
import { Row, Col } from "reactstrap"
import Layout from "../Layout"
import privacyPolicy from "./privacyPolicy.json"
import "./privacypolicy.scss"
import { withRouter } from "../../utils/routes.utils"

const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children)

const PrivacyPolicy = ({ isAuthed }) => {
  window.scrollTo(0, 0)

  function renderBody(policy) {
    const searchTerm = "billgist"

    const textArray = policy.body.split(searchTerm)

    const bodyWithHighlightedTerm = textArray.map((item, index) => {
      const modified_search_term = index !== textArray.length - 1 ? `<strong>${searchTerm}</strong>` : ""

      return (
        <Fragment key={index}>
          {item}
          {modified_search_term}
        </Fragment>
      )
    })

    const htmlContent = bodyWithHighlightedTerm
      .map((child) => {
        if (typeof child === "string") {
          return child
        }
        if (React.isValidElement(child)) {
          return React.Children.toArray(child.props.children).join("")
        }
        return ""
      })
      .join("")

    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  }

  return (
    <>
      <ConditionalWrapper condition={!isAuthed} wrapper={(children) => <Layout privacy>{children}</Layout>}>
        <div className="section text-start mx-0 mb-0 pt-2 pb-0 px-0" id="privacypolicy">
          <div className="container-lg px-5">
            <h1 className="px-2">Privacy Policy</h1>
            <p className="px-2">Effective: January 14th, 2025</p>
            <p className="px-2">
              <strong>Welcome to Billgist!</strong>
            </p>
            <p className="px-2">
              Billgist is a cloud cost management tool that aims to make your life easier when it comes to managing your
              AWS bill.
              <br />
              We value your privacy and are committed to ensuring the security of your data when using our services.
              This Privacy Policy outlines the details of permissions granted during AWS account integration and how we
              safeguard your information.
            </p>
          </div>
        </div>
        <div className="container-lg">
          <Row className="section text-start mx-0 mb-2 pt-0" id="privacypolicy">
            {privacyPolicy.privacy_policy.map((policy, i) => (
              <Col xs={12} sm={12} key={i} className="mb-2">
                <strong>{policy.head}</strong>
                {renderBody(policy)}
              </Col>
            ))}
          </Row>
        </div>
      </ConditionalWrapper>
    </>
  )
}

export default withRouter(PrivacyPolicy)
